(function ($) {
        $('.accordion > .accordion-item:first-child .accordion-head').addClass('active').next().slideDown();

        $('.accordion .accordion-head').click(function (j) {
          var dropDown = $(this).closest('.accordion-item').find('.accordion-content');
          if ($(this).hasClass('active')) {
            $(this).removeClass('active');
          } else {
            $(this)
              .closest('.accordion')
              .find('.accordion-head.active')
              .closest('.accordion-item')
              .find('.accordion-content')
              .slideUp();
            $(this).closest('.accordion').find('.accordion-head.active').removeClass('active');
            $(this).addClass('active');
          }

          dropDown.stop(false, true).slideToggle();

          j.preventDefault();
        });
      })(jQuery);
